import React, { memo } from 'react'
import styled from 'styled-components'
import { TextBody, get } from '@ally/metronome-ui'
import { Private } from '@ally/private'
import { CheckDetails } from '../../types'

const StyledImg = styled.img`
  width: 600px;
  margin: ${get.space('xxs')} 0 ${get.space('xs')};
`

const DetailHeading = styled(TextBody).attrs(props => ({
  size: 'sm',
  tag: 'span',
  weight: 'bold',
}))`
  margin-right: ${get.space('xs')};
`

interface PriceCheckDetails {
  printCheckDetails: CheckDetails
}

export const PrintCheck: React.FC<PriceCheckDetails> = memo(
  ({ printCheckDetails }) => {
    return (
      <>
        <TextBody size="md" tag="p">
          {`${printCheckDetails.productDescription} Account`}
        </TextBody>
        {printCheckDetails.accountNickname && (
          // TODO- add test coverage and remove ignore
          /* istanbul ignore next */
          <TextBody size="md" tag="p" weight="bold">
            {printCheckDetails.accountNickname}
          </TextBody>
        )}
        <TextBody size="sm" tag="p">
          <DetailHeading>Account Number:</DetailHeading>
          {printCheckDetails.accountNumber}
        </TextBody>
        <TextBody size="sm" tag="p">
          <DetailHeading>Routing Number:</DetailHeading>
          124003116
        </TextBody>
        <TextBody size="sm" tag="p">
          <DetailHeading>Available Balance:</DetailHeading>
          {printCheckDetails.availableBalance}
        </TextBody>
        <TextBody size="sm" tag="p">
          <DetailHeading>Amount:</DetailHeading>
          {printCheckDetails.amount}
        </TextBody>
        <TextBody size="sm" tag="p">
          <DetailHeading>Posting Date:</DetailHeading>
          {printCheckDetails.postingDate}
        </TextBody>
        <TextBody size="sm" tag="p">
          <DetailHeading>Posting Time:</DetailHeading>
          {printCheckDetails.postingTime}
        </TextBody>
        <TextBody size="sm" tag="p">
          <DetailHeading>Type:</DetailHeading>
          {printCheckDetails.type}
        </TextBody>
        <TextBody size="xs" weight="bold" tag="p">
          FRONT OF CHECK
        </TextBody>
        <Private>
          <StyledImg
            src={printCheckDetails.frontCheckImage}
            alt="front of check"
            data-testid="frontCheckImage"
          />
        </Private>
        <TextBody size="xs" weight="bold" tag="p">
          BACK OF CHECK
        </TextBody>
        <Private>
          <StyledImg
            src={printCheckDetails.backCheckImage}
            alt="back of check"
            data-testid="backCheckImage"
          />
        </Private>
      </>
    )
  },
)
